import { render, staticRenderFns } from "./BuyNftView.vue?vue&type=template&id=b899b554&scoped=true"
import script from "./BuyNftView.vue?vue&type=script&lang=js"
export * from "./BuyNftView.vue?vue&type=script&lang=js"
import style0 from "./BuyNftView.vue?vue&type=style&index=0&id=b899b554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899b554",
  null
  
)

export default component.exports